import { Chain, Reward } from '@prisma/client';

export const USDC_TOKEN_ADDRESS = '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48';

export const DEFAULT_DECIMALS = 18;

// NOTE: update zod tokenFormat enum if you add tokens to this file

export function getRewardString(reward?: Reward | null): string {
  if (!reward) return '';
  if (reward.type === 'REVENUE_SHARE') {
    if (reward.percentage) return `${reward.percentage}%`;
    return '';
  }
  if (reward.type === 'FIXED') {
    const symbol = reward.tokenSymbol || reward.tokenName;
    if (symbol && reward.tokenAmount) return `${reward.tokenAmount} ${symbol}`;
    return '';
  }
  // TODO handled TIERED rewards
  return '';
}

type Token = { name: string; symbol: string; address: string; decimals: number };
type ChainTokens = Record<string, Token>;

const NATIVE_TOKEN_ADDRESS = '0x0';

const ETH_PREDEFINED_TOKENS: ChainTokens = {
  ETH: { name: 'ETH', symbol: 'ETH', address: NATIVE_TOKEN_ADDRESS, decimals: DEFAULT_DECIMALS },
  USDC: {
    name: 'USDC',
    symbol: 'USDC',
    address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    decimals: 6,
  },
  USDT: {
    name: 'USDT',
    symbol: 'USDT',
    address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    decimals: 6,
  },
};

const POLYGON_PREDEFINED_TOKENS: ChainTokens = {
  ETH: {
    name: 'MATIC',
    symbol: 'MATIC',
    address: NATIVE_TOKEN_ADDRESS,
    decimals: DEFAULT_DECIMALS,
  },
  USDC: {
    name: 'USDC',
    symbol: 'USDC',
    address: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    decimals: 6,
  },
  USDT: {
    name: 'USDT',
    symbol: 'USDT',
    address: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    decimals: 6,
  },
};

const OPTIMISM_PREDEFINED_TOKENS: ChainTokens = {
  ETH: { name: 'ETH', symbol: 'ETH', address: NATIVE_TOKEN_ADDRESS, decimals: DEFAULT_DECIMALS },
  USDC: {
    name: 'USDC',
    symbol: 'USDC',
    address: '0x7F5c764cBc14f9669B88837ca1490cCa17c31607',
    decimals: 6,
  },
  USDT: {
    name: 'USDT',
    symbol: 'USDT',
    address: '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
    decimals: 6,
  },
};

const ARBITRUM_PREDEFINED_TOKENS: ChainTokens = {
  ETH: { name: 'ETH', symbol: 'ETH', address: NATIVE_TOKEN_ADDRESS, decimals: DEFAULT_DECIMALS },
  USDC: {
    name: 'USDC',
    symbol: 'USDC',
    address: '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8',
    decimals: 6,
  },
  USDT: {
    name: 'USDT',
    symbol: 'USDT',
    address: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
    decimals: 6,
  },
};

const GOERLI_PREDEFINED_TOKENS: ChainTokens = {
  ETH: { name: 'ETH', symbol: 'ETH', address: NATIVE_TOKEN_ADDRESS, decimals: DEFAULT_DECIMALS },
  USDC: {
    name: 'USDC',
    symbol: 'USDC',
    address: '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8',
    decimals: 6,
  },
  USDT: {
    name: 'USDT',
    symbol: 'USDT',
    address: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
    decimals: 6,
  },
};

export const PREDEFINED_TOKENS: Record<Chain, ChainTokens> = {
  [Chain.ETHEREUM]: ETH_PREDEFINED_TOKENS,
  [Chain.POLYGON]: POLYGON_PREDEFINED_TOKENS,
  [Chain.OPTIMISM]: OPTIMISM_PREDEFINED_TOKENS,
  [Chain.ARBITRUM]: ARBITRUM_PREDEFINED_TOKENS,
  [Chain.GOERLI]: GOERLI_PREDEFINED_TOKENS,
  [Chain.SOLANA]: {},
  [Chain.FIAT]: {},
  [Chain.EVM]: {},
};
